var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('Gap',{attrs:{"md":32,"xs":16}}),_c('div',{staticClass:"center-container"},[_c('div',{staticStyle:{"max-width":"700px"}},[_c('Map')],1)]),_c('Gap',{attrs:{"md":32,"xs":16}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }